import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyParseJson',
})
export class ParseJsonPipe implements PipeTransform {
    transform(value: string): any {
        return JSON.parse(value);
    }
}
